const hasOwnProperty = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export { hasOwnProperty };
